import {Component, inject} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {StagingAuthService} from '../../../shared/services/staging-auth.service';

@Component({
  selector: 'app-staging-login',
  imports: [ReactiveFormsModule],
  template: `
    <div class="login-container">
      <h2>Login Required</h2>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="username">Username</label>
          <input type="text" id="username" formControlName="username" />
        </div>
        <div class="form-group">
          <label for="password">Password</label>
          <input type="password" id="password" formControlName="password" />
        </div>
        @if (error) {
          <div class="error-message">
            {{ error }}
          </div>
        }
        <button type="submit" [disabled]="loginForm.invalid">Login</button>
      </form>
    </div>
  `,
  styles: [
    `
      .login-container {
        max-width: 400px;
        margin: 50px auto;
        padding: 20px;
        border: 1px solid #ccc;
        border-radius: 5px;
      }

      .form-group {
        margin-bottom: 15px;
      }

      input {
        width: 100%;
        padding: 8px;
      }

      .error-message {
        color: red;
        margin: 10px 0;
      }
    `,
  ],
})
export class StagingLoginComponent {
  loginForm: FormGroup;
  error = '';
  returnUrl = '/';

  private readonly fb = inject(FormBuilder);
  private readonly route = inject(ActivatedRoute);
  private readonly stagingAuthService = inject(StagingAuthService);

  constructor() {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  onSubmit(): void {
    if (this.loginForm.invalid) return;

    const {username, password} = this.loginForm.value;

    if (this.stagingAuthService.login(username, password)) {
      window.location.href = this.returnUrl.startsWith('/')
        ? window.location.origin + this.returnUrl
        : this.returnUrl;
    } else {
      this.error = 'Invalid username or password';
    }
  }
}
